import { Edit } from '@mui/icons-material';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import React, { useState, ChangeEvent, useEffect } from "react";
interface Props {
  title: string;
  setTitle: (val: string) => void;
}

export const EditableTitle: React.FC<Props> = ({ title, setTitle }) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [localTitle, setLocalTitle] = useState(title || "");

  useEffect(() => {
    setLocalTitle(title);
  }, [title]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    setTitle(localTitle);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setLocalTitle(e.target.value);
  };

  return (
    <div>
      {isEditing ? (
        <TextField
          value={localTitle}
          onChange={handleChange}
          onBlur={handleBlur}
          autoFocus
          sx={{ width: "50%" }}
        />
      ) : (
        <Box display="flex">
          <Typography variant="h5" color="primary">
            {title}
          </Typography>
          <IconButton onClick={handleEditClick}>
            <Edit />
          </IconButton>
        </Box>
      )}
    </div>
  );
};
